import { Badge, Switch } from '@lib/components'
import type React from 'react'

import { clsJoin } from '@/utils'
import type { PROJECT_SHARE_TYPE } from '../../types'
import { useAnonymousCommentsToggle, useCanToggle } from './hooks'
import css from './styles.module.css'

interface Props {
  share: PROJECT_SHARE_TYPE
}

export const AnonymousCommentsToggle: React.FC<Props> = () => {
  const { state, onChange, onClickBadge } = useAnonymousCommentsToggle()

  const { disabled, badge } = useCanToggle()

  const headerCls = clsJoin(css.header, badge && css.disabled)
  const descriptionCls = clsJoin(css.description, badge && css.disabled)

  return (
    <div className={css.anonymous_toggle_toggle_wrapper}>
      <label className={css.label}>
        <span className={headerCls}>Guest comments</span>
        <span className={descriptionCls}>
          Allow non-logged users to comment
        </span>
      </label>
      <div className={css.toggle_wrapper}>
        {!badge && (
          <Switch checked={state} disabled={disabled} onChange={onChange} />
        )}
        {badge && <Badge onClick={onClickBadge} type="plan_pro" />}
      </div>
    </div>
  )
}
